import { HttpClient } from "@effect/platform";
import { Effect } from "effect";
import { notifyRequestFailure } from "@/lib/deployment/request-failures";

/** Observe HTTP refusals and transport failures before a typed caller decodes them. */
export const withRequestFailureChecks = (client: HttpClient.HttpClient) =>
  HttpClient.transformResponse(client, (response) =>
    response.pipe(
      Effect.tap((response) =>
        response.status >= 400
          ? Effect.sync(notifyRequestFailure)
          : Effect.void,
      ),
      Effect.tapError(() => Effect.sync(notifyRequestFailure)),
    ),
  );
